import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get("next") || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back");
      nav(next);
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-[80vh] flex items-center">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 w-full grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-novya-muted">Sign in</div>
          <h1 className="mt-6 font-display font-black text-5xl md:text-6xl tracking-tighter leading-[0.95] text-novya-ink">
            Welcome back.
          </h1>
          <p className="mt-6 text-novya-muted max-w-md leading-relaxed">
            Log in to see your enrolled programs, upcoming sessions, and capstone progress.
          </p>
        </div>

        <form onSubmit={submit} className="md:col-span-6 md:col-start-7 border border-novya-border p-8 md:p-12 bg-white">
          <div className="space-y-6">
            <label className="block">
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-novya-muted">Email</span>
              <input
                data-testid="login-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full border-b border-novya-ink bg-transparent py-3 outline-none focus:border-novya-accent"
              />
            </label>
            <label className="block">
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-novya-muted">Password</span>
              <input
                data-testid="login-password-input"
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 w-full border-b border-novya-ink bg-transparent py-3 outline-none focus:border-novya-accent"
              />
            </label>
          </div>
          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={loading}
            className="mt-10 w-full py-4 bg-novya-ink text-white font-medium hover:bg-novya-accent transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <p className="mt-6 text-sm text-novya-muted">
            No account yet? <Link to="/register" data-testid="login-to-register" className="text-novya-ink font-medium link-underline">Apply here</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
